import { render, staticRenderFns } from "./LvInfoTaskLinks.vue?vue&type=template&id=048372aa"
import script from "./LvInfoTaskLinks.vue?vue&type=script&lang=js"
export * from "./LvInfoTaskLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports